// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reveal .controls,
.reveal .progress,
.nca-color,
a.nca-color {
  color: #5fbb28;
}

.logo {
  position: absolute;
  top: 30px;
  right: 10px;
  border: 0;
  z-index: 1;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.yellow {
  color: yellow;
}

.nca-col {
}
.nca-col:after {
  clear: both;
}
.nca-col-2 {
  float: left;
  width: 50%;
}
.nca-col-3 {
  float: left;
  width: 33%;
}

.text-left {
  text-align: left;
}

div.font-fourtyfive-percent {
  font-size: 45%;
}

div.font-fifty-percent {
  font-size: 50%;
}

div.font-sixty-percent {
  font-size: 60%;
}

div.font-seventy-percent {
  font-size: 70%;
}

/* Overwrites */
.reveal section img {
  border: 0;
  background: none;
  margin-top: 0px;
  max-height: 500px;
}

.fragment.blur {
  filter: blur(5px);
}
.fragment.blur.visible {
  filter: none;
}

/*Bildkorrektur*/

.portrait {
  display: grid;
  grid-template-columns: 1fr 1fr;
}

pre code {
  white-space: pre-wrap; /* CSS 3 */
  white-space: -moz-pre-wrap; /* Mozilla, seit 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
`, "",{"version":3,"sources":["webpack://./src/css/nca.css"],"names":[],"mappings":"AAAA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;AACA;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB,EAAE,UAAU;EACjC,0BAA0B,EAAE,uBAAuB;EACnD,sBAAsB,EAAE,cAAc;EACtC,wBAAwB,EAAE,YAAY;EACtC,qBAAqB,EAAE,2BAA2B;AACpD","sourcesContent":[".reveal .controls,\n.reveal .progress,\n.nca-color,\na.nca-color {\n  color: #5fbb28;\n}\n\n.logo {\n  position: absolute;\n  top: 30px;\n  right: 10px;\n  border: 0;\n  z-index: 1;\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  -o-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.yellow {\n  color: yellow;\n}\n\n.nca-col {\n}\n.nca-col:after {\n  clear: both;\n}\n.nca-col-2 {\n  float: left;\n  width: 50%;\n}\n.nca-col-3 {\n  float: left;\n  width: 33%;\n}\n\n.text-left {\n  text-align: left;\n}\n\ndiv.font-fourtyfive-percent {\n  font-size: 45%;\n}\n\ndiv.font-fifty-percent {\n  font-size: 50%;\n}\n\ndiv.font-sixty-percent {\n  font-size: 60%;\n}\n\ndiv.font-seventy-percent {\n  font-size: 70%;\n}\n\n/* Overwrites */\n.reveal section img {\n  border: 0;\n  background: none;\n  margin-top: 0px;\n  max-height: 500px;\n}\n\n.fragment.blur {\n  filter: blur(5px);\n}\n.fragment.blur.visible {\n  filter: none;\n}\n\n/*Bildkorrektur*/\n\n.portrait {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n}\n\npre code {\n  white-space: pre-wrap; /* CSS 3 */\n  white-space: -moz-pre-wrap; /* Mozilla, seit 1999 */\n  white-space: -pre-wrap; /* Opera 4-6 */\n  white-space: -o-pre-wrap; /* Opera 7 */\n  word-wrap: break-word; /* Internet Explorer 5.5+ */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
